"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var _kernel_store_types_1 = require("../../types");
var MAX_DOWNLOAD_ERROR_ITERATION = 8;
var MediafileService = (function () {
    function MediafileService() {
    }
    MediafileService.getCacheStateFromMediafile = function (mediafile) {
        var _a;
        var _b = __read(mediafile.files, 1), firstFile = _b[0];
        return (_a = firstFile === null || firstFile === void 0 ? void 0 : firstFile.cacheState) !== null && _a !== void 0 ? _a : _kernel_store_types_1.EMediafileCacheState.NO_CACHE;
    };
    MediafileService.getMediafileFile = function (mediafile, filename) {
        return mediafile.files.find(function (file) { return file.filename === filename; });
    };
    MediafileService.getFileFromMediafile = function (mediafile) {
        return mediafile.files.length > 0
            ? __assign(__assign({}, mediafile.files[0]), { mediafileId: mediafile.id }) : null;
    };
    MediafileService.getFileErrorDownloadDelay = function (targetDelay, increaseDelay, delay) {
        var newIteration = delay ? delay.iteration + 1 : 1;
        var newDelay = Date.now() +
            targetDelay *
                (increaseDelay
                    ? newIteration <= MAX_DOWNLOAD_ERROR_ITERATION
                        ? newIteration
                        : MAX_DOWNLOAD_ERROR_ITERATION
                    : 1);
        return {
            iteration: newIteration,
            delay: newDelay,
        };
    };
    MediafileService.mergeMediafiles = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return utils_1.mergeMediafiles.apply(void 0, __spreadArray([], __read(args), false));
    };
    MediafileService.getFileCompositeKey = function (file) {
        return "".concat(file.mediafileId).concat(file.filename);
    };
    MediafileService.getMediafileDownloadDelay = function (file, errorList) {
        var _a, _b;
        return (_b = (_a = errorList[this.getFileCompositeKey(file)]) === null || _a === void 0 ? void 0 : _a.delay) !== null && _b !== void 0 ? _b : null;
    };
    MediafileService.shouldBeDelayed = function (delay) {
        return !!delay && Date.now() < delay;
    };
    return MediafileService;
}());
exports.default = MediafileService;
//# sourceMappingURL=index.js.map